import userStore from "data/userStore";
import StereotypesStore from "../StereotypesStore";
import entityMetaStore from "data/meta/entityMetaStore";
import { toSlice } from "data/slices";

export const isCreatableFrom = (stereoInfo, entityKey) => {
    for (const c of stereoInfo.creatables) {
        for (const v of c.versions) {
            if (v.key === entityKey) return true;
        }
    }
    return false;
};

export const buildMenu = (stereotypeKey) => {
    if ((stereotypeKey == null)) {
        throw new Error("key is required to build menu");
    }
    const stereotype = StereotypesStore.getStereotypeByKey(stereotypeKey);
    const creatables = stereotype.creatables;
    const implsByKey = toSlice(stereotype.implementations, "key").byKey;
    const tree = [];
    const org = userStore.getActiveOrg();
    const canCreate = ek => {
        // full entity models aren't available yet...
        const impl = implsByKey[ek];
        if (!userStore.canCreate(impl.implementationKey)) return false;
        if (!impl.lookup) return true;
        return userStore.canManageLookups(impl.implementationKey);
    };

    _(creatables).filter(c =>
        _(c.orgs).contains(org.key)
    ).forEach(function(c) {
        let def;
        if (c.hasOwnProperty("defaultKey")) {
            def = c.versions.find(v => v.key === c.defaultKey);
        }
        const label = c.label;
        if (def != null) {
            if(!canCreate(def.key)) {
                return; // does not have create permissions for this implementation.
            }
            return tree.push({
                label,
                key: def.key,
                org: org.key,
                entity: stereotypeKey
            });
        } else {
            return c.versions.forEach(v => {
                if(!canCreate(v.key)) {
                    return; // does not have create permissions for this implementation.
                }
                tree.push({
                    label: label + " > " + v.label,
                    key: v.key,
                    org: org.key,
                    entity: stereotypeKey
                });
            });
        }
    });
    return squishMenuList(tree);
};

const squishMenuList = (list) => {
    const result = [];
    for (const item of list) {
        result.push(squishMenuItem(item));
    }
    return result;
};

const squishMenuItem = (item) => {
    // TODO: figure out where "kids" come from. At first glance this seems
    // unnecessary because we never create any kids property in buildMenu?
    // Possibly bad BB conversion?
    if (item.kids) {
        const kids = this.squishMenuList(item.kids);
        const newItem = {...item};
        newItem.kids = kids;
        if (kids.size() === 1) {
            const kid = kids.pop(); // remove it
            kid.label = newItem.label + " > " + kid.label;
            return kid;
        }
        return newItem;
    }
    return item;
};

export const getImplementations = (stereoInfo, access, recordId) =>
    stereoInfo.implementations.filter(imp =>
        access.hasEntityRecord(imp.key, recordId)
    );

export const getTableKeys = (stereoInfo) => {
    const tableKeys = [];
    stereoInfo.creatables.forEach((it) => {
        it.versions.forEach(ver => {
            const t = entityMetaStore.getInfo(ver.key).tableKey;
            if(!tableKeys.includes(t)) {
                tableKeys.push(t);
            }
        });
    });
    return tableKeys;
};



// WEBPACK FOOTER //
// ./app/data/selectors/stereotypes.js